// extracted by mini-css-extract-plugin
export default {"FormContainer":"BoardMember_FormContainer__tzJPL","NameListItem":"BoardMember_NameListItem__mfjYd","DeleteButton":"BoardMember_DeleteButton__sZ9gL"};